import { render, staticRenderFns } from "./name-card0.vue?vue&type=template&id=159939ee&scoped=true&"
import script from "./name-card0.vue?vue&type=script&lang=js&"
export * from "./name-card0.vue?vue&type=script&lang=js&"
import style0 from "./name-card0.vue?vue&type=style&index=0&id=159939ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159939ee",
  null
  
)

export default component.exports